import { render, staticRenderFns } from "./StudentPerformance.vue?vue&type=template&id=d0724bf0&scoped=true&"
import script from "./StudentPerformance.vue?vue&type=script&lang=ts&"
export * from "./StudentPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./StudentPerformance.vue?vue&type=style&index=0&id=d0724bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0724bf0",
  null
  
)

export default component.exports